"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var environment_1 = require("../../environments/environment");
var tare_weight_1 = require("./tare-weight");
var api_service_1 = require("../shared/api.service");
var TareWeightService = /** @class */ (function () {
    function TareWeightService(http) {
        this.http = http;
        this.baseUrl = environment_1.environment.serverUrl + 'tareweights/';
    }
    TareWeightService.prototype.getTareWeight = function (tareWeightId) {
        var tareWeightUrl = this.baseUrl + tareWeightId + '/';
        return this.http.get(tareWeightUrl, { headers: api_service_1.requestHeaders() }).pipe(operators_1.map(this.extractData), operators_1.catchError(api_service_1.handleError));
    };
    TareWeightService.prototype.getTareWeights = function (query) {
        var _this = this;
        if (query === void 0) { query = null; }
        var params = new http_1.HttpParams();
        if (query) {
            Object.keys(query).forEach(function (key) {
                if (typeof query[key] !== 'undefined' && query[key] && query[key].toString) {
                    params = params.set(key, query[key].toString());
                }
            });
        }
        var scalesUrl = this.baseUrl;
        return this.http.get(scalesUrl, {
            headers: api_service_1.requestHeaders(),
            params: params
        }).pipe(operators_1.map(function (res) { return _this.extractData(res); }), operators_1.catchError(api_service_1.handleError));
    };
    TareWeightService.prototype.extractData = function (res) {
        var resObj = res;
        this.nextUri = resObj['next'];
        this.count = resObj['count'];
        var body = resObj['results'];
        if (body) {
            return body.map(function (scale) {
                return new tare_weight_1.TareWeight(scale);
            });
        }
        else if (resObj) {
            return new tare_weight_1.TareWeight(resObj);
        }
    };
    TareWeightService.prototype.getNext = function () {
        var _this = this;
        if (this.nextUri) {
            return this.http.get(this.nextUri, {
                headers: api_service_1.requestHeaders()
            }).pipe(operators_1.map(function (res) { return _this.extractData(res); }), operators_1.catchError(api_service_1.handleError));
        }
        else {
            return null;
        }
    };
    return TareWeightService;
}());
exports.TareWeightService = TareWeightService;
